import { Fragment, h } from 'preact';
import { useLayoutEffect } from 'preact/compat';
import { useState } from 'preact/hooks';
import { GeoJSON, MapContainer, TileLayer, Tooltip } from 'react-leaflet';

import NYC from '../../assets/nyc.geojson.json';
import './CondensedAttribution'; // this also transitively import Leaflet into the global namespace
import ContentCard from '../ContentCard';
import { GeolocationControl } from './GeolocationControl';
import SearchArea from './SearchArea';

export default function CoffeeMap({ interactive }: { interactive: boolean }) {
    const [ready, setReady] = useState(false);
    useLayoutEffect(() => setReady(true), []);

    return (
        <ContentCard overrides={{
            Contents: {
                style: {
                    flexGrow: '1',
                    marginBottom: '0',
                    marginLeft: '0',
                    marginRight: '0',
                    marginTop: '0',
                },
            },
        }}>
            {ready && (<MapContainer attributionControl={false}
                                     center={[40.7127281, -74.0060152]}
                                     maxBounds={[[40.45, -74.28], [40.94, -73.68]]}
                                     maxBoundsViscosity={1}
                                     maxZoom={16}
                                     minZoom={11}
                                     style={{
                                         height: '100%',
                                         minHeight: '307px',
                                         minWidth: '307px',
                                         width: '100%',
                                     }}
                                     zoom={11}>
                <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                           url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                {interactive && (<>
                    <GeoJSON data={NYC}>
                        <Tooltip direction="left">
                            Unfortunately, we only support the NYC area for now.
                        </Tooltip>
                    </GeoJSON>
                    <GeolocationControl drawCircle={false}
                                        drawMarker={false}
                                        flyTo
                                        locateOptions={{ watch: false }}
                                        onLocationError={console.error}
                                        onLocationOutsideMapBounds={control => control.stop()}
                                        setView="once"
                                        strings={{ title: 'Use my location' }} />
                </>)}
                <SearchArea interactive={interactive} />
            </MapContainer>)}
        </ContentCard>
    );
}
